import styled from 'styled-components';

import i18n from '../../../../../app/i18n';
import {
  Tr,
  Th,
  ThContentWrapper,
} from '../../../../../shared/TableComponents/StyledComponents';
import Sort from '../../../../../shared/Sort/Sort.jsx';

const tableColumns = [
  { name: 'name', title: i18n.t('prizes:pickWinners.name'), sort: true },
  { name: 'tickets', title: i18n.t('prizes:pickWinners.chances'), sort: true },
  { name: 'email', title: i18n.t('prizes:pickWinners.email'), sort: true },
];

const TableHead = ({ sortingStatus, changeSort }) => (
  <thead>
    <Tr>
      {tableColumns.map(column => (
        <StyledTh key={column.name} columnName={column.name}>
          <ThContent
            sortEnabled={column.sort}
            columnName={column.name}
            onClick={() => column.sort && changeSort(column.name)}
          >
            {column.sort && (
              <Sort sortingStatus={sortingStatus} columnName={column.name} />
            )}
            <ColumnTitle>{column.title}</ColumnTitle>
          </ThContent>
        </StyledTh>
      ))}
    </Tr>
  </thead>
);

export default TableHead;

const ColumnTitle = styled.p`
  padding: 0 0 0 8px;
  margin: 0;
`;

const StyledTh = styled(Th)`
  padding: ${({ columnName }) =>
    columnName === 'name'
      ? '0 15px 12px 24px !important'
      : '0 60px 12px 0 !important'};
`;

const ThContent = styled(ThContentWrapper)`
  cursor: ${({ sortEnabled }) => (sortEnabled ? 'pointer' : 'default')};
  justify-content: ${({ columnName }) =>
    columnName === 'tickets' ? 'flex-end' : 'flex-start'};
`;
